/*
export const someMutation = (state) => {}
 */
import _ from 'lodash'
import { initialState } from './state'
import Vue from 'vue'
export default {
  isLoading,
  doneLoading,
  isSaving,
  doneSaving,
  toggleMaximized,
  openUserModal,
  closeDetails,
  openUserWizardModal,
  closeUserWizardModal,
  setList,
  setAutoCompleteList,
  setManagerAutoCompleteList,
  setAffiliateAutoCompleteList,
  setInstructorList,
  setInstructorClassList,
  setAffiliateList,
  setRecruiterList,
  setManagerList,
  setAdministratorList,
  setSelectedUser,
  setSameAsBilling,
  setActiveApproval,
  updateActiveApproval,
  updateEditState,
  updateRole,
  updateRoles,
  updateManagerCourses,
  updateUserForm,
  updateStudentForm,
  updateBillingAddressForm,
  updateShippingAddressForm,
  updateInstructorForm,
  updateRecruiterForm,
  updateAffiliateForm,
  updateManagerForm,
  updateAdministratorForm,
  updateSelectedTab,
  setUserForm,
  setBillingAddressForm,
  setShippingAddressForm,
  setInstructorForm,
  setRecruiterForm,
  setAffiliateForm,
  setManagerForm,
  setAdministratorForm,
  setNotificationSettings,
  clearUserForm,
  clearBillingAddressForm,
  clearShippingAddressForm,
  clearInstructorForm,
  clearRecruiterForm,
  clearAffiliateForm,
  clearManagerForm,
  clearAdministratorForm,
  clearActiveApproval,
  changeSearchType,
  resetSearchFields,
  activeSearchType,
  resetSelectedUser,
  resetState,
  autocompleteAddress,
  loadingUserClasses,
  loadingAffiliateManagers,
  setManagersForAffiliate,
  updateSelectedAffiliateManagers,
  updateAffiliateManagerModalOpen,
  setAffiliateManager,
  loadingManagerAffiliates,
  setAffiliatesForManager,
  setManagerAffiliate,
  updateSelectedManagerAffiliates,
  updateManagerAffiliateModalOpen,
  setInvalidUserRoles,
  setMigrateOpen,
  setMigrateInstructor,
  setMigratingInstructor,
  setCustomerPaymentProfiles,
  setLoadingPaymentProfiles
}

function setLoadingPaymentProfiles(state, payload){
  state.billingForm.loading = payload
}

function setCustomerPaymentProfiles(state, payload){
  state.billingForm.paymentProfiles = payload
}

function setMigrateOpen(state, payload){
  state.migrateOpen = payload
}

function setMigratingInstructor(state, payload){
  state.migratingInstructor = payload
}

function setMigrateInstructor(state, payload){
  state.selectedMigrateInsturctor = payload ? payload.item.INSTRUCTOR_ID : null
}

function setInvalidUserRoles(state,payload){
  state.userWizardModal.invalidUserRoles = payload
}

function setManagerAffiliate(state,payload){
  state.currentManagerAffiliateManager = payload
}

function updateManagerAffiliateModalOpen(state, payload){
  state.managerAffiliateModalOpen = payload
}
function setManagersForAffiliate(state, payload){
  state.affiliateManagers = payload.rows
}

function setAffiliateManager(state,payload){
  state.currentManagerAffiliateManager = payload
}

function updateAffiliateManagerModalOpen(state, payload){
  state.affiliateManagerModalOpen = payload
}

function updateSelectedAffiliateManagers (state, selectedManagers) {
  state.selectedAffiliateManagers = [...selectedManagers]
}

function loadingAffiliateManagers(state, payload){
  state.affiliateManagersLoading = payload
}

function setAffiliatesForManager(state, payload){
  state.managerAffiliates = payload.rows
}

function updateSelectedManagerAffiliates (state, selectedManagers) {
  state.selectedManagerAffiliates = [...selectedManagers]
}

function loadingManagerAffiliates(state, payload){
  state.managerAffiliateLoading = payload
}

function isLoading (state) {
  state.loadingData = true
}

function loadingUserClasses(state, payload){
  state.userClassesLoading = payload
}

function doneLoading (state) {
  state.loadingData = false
}

function isSaving (state) {
  state.savingUser = true
}

function doneSaving (state) {
  state.savingUser = false
}

function toggleMaximized (state, payload) {
  state.userModal.maximized = !state.userModal.maximized
}

function openUserModal (state, { mode }) {
  state.userModal.mode = mode
  state.userModal.open = true
}

function closeDetails (state) {
  state.userModal.open = false
  state.selectedUser = {}
  state.userModal.selectedTab = 'general'
  state.savingUser = false
}

function openUserWizardModal (state) {
  state.userWizardModal.open = true
  state.userModal.canEdit = true
  /**
   * Lets make sure the state gets reset.
   */
  Vue.set(state, 'userForm', _.cloneDeep(initialState.userForm))
  Vue.set(state, 'billingAddressForm', _.cloneDeep(initialState.billingAddressForm))
  Vue.set(state, 'shippingAddressForm', _.cloneDeep(initialState.shippingAddressForm))
  Vue.set(state, 'instructorForm', _.cloneDeep(initialState.instructorForm))
  Vue.set(state, 'recruiterForm', _.cloneDeep(initialState.recruiterForm))
  Vue.set(state, 'affiliateForm', _.cloneDeep(initialState.affiliateForm))
  Vue.set(state, 'managerForm', _.cloneDeep(initialState.managerForm))
  Vue.set(state, 'administratorForm', _.cloneDeep(initialState.administratorForm))
}

function closeUserWizardModal (state) {
  state.userWizardModal.open = false
}

function resetSelectedUser (state) { 
  state.selectedUser = {}
}

function updateRole (state, { role }) {
  state.role = role
}

function setList (state, { users }) {
  state.list = users
}

function setAutoCompleteList (state, { users }) {
  state.autoCompleteList = users
}

function setManagerAutoCompleteList (state, { managers }) {
  state.managerAutoCompleteList = managers
}

function setAffiliateAutoCompleteList (state, { affiliates }) {
  state.affiliateAutoCompleteList = affiliates
}

function setInstructorList (state, { instructors }) {
  state.instructorList = instructors
}

function setInstructorClassList (state, { classes }) {
  state.instructorClassList = classes
}

function setAffiliateList (state, { affiliates }) {
  state.affiliateList = affiliates
}

function setRecruiterList (state, { recruiters }) {
  state.recruiterList = recruiters
}

function setManagerList (state, { managers }) {
  state.managerList = managers
}

function setAdministratorList (state, { administrators }) {
  state.administratorList = administrators
}

function setSelectedUser (state, { user }) {
  state.selectedUser = user
}

function setSameAsBilling (state, { status, initialLoad }) {
  // Reset the mailing address form, but lets try to keep the ID if it's there.
  state.shippingAddressForm.sameAsBilling = status
  if (status === false && !initialLoad) {
    state.shippingAddressForm = { ...initialState.shippingAddressForm }
  }
}

function setActiveApproval (state, { instructor, approvalHistory }) {
  state.activeApproval = instructor
  state.activeApproval.history = approvalHistory
}
function updateActiveApproval (state, { field, value }) {
  Object.assign(state.activeApproval, {
    [field]: value
  })
}

function updateEditState (state, payload) {
  state.userModal.canEdit = payload
}

function updateRoles (state, roles) {
  state.roles = roles
}

function updateManagerCourses (state, courses) {
  state.managerCourses = courses
}

function updateUserForm (state, { field, value }) {
  Object.assign(state.userForm, {
    [field]: value
  })
}

function updateBillingAddressForm (state, { field, value }) {
  Object.assign(state.billingAddressForm, {
    [field]: value
  })
}

function updateShippingAddressForm (state, { field, value }) {
  Object.assign(state.shippingAddressForm, {
    [field]: value
  })
}

function updateStudentForm (state, { field, value }) {
  Object.assign(state.studentForm, {
    [field]: value
  })
}

function updateInstructorForm (state, { field, value }) {
  Object.assign(state.instructorForm, {
    [field]: value
  })
}

function updateRecruiterForm (state, { field, value }) {
  Object.assign(state.recruiterForm, {
    [field]: value
  })
  // Vue.set(state.recruiterForm, '')
}

function updateAffiliateForm (state, { field, value }) {
  if(field == 'FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER'){
    let regex = /^[\d-]+$/
    if(!regex.test(value)) return
  }
  if(field == 'PRINT_PERMISSION'){
    console.log(value)
    value = !state.affiliateForm.PRINT_PERMISSION ? 1 : 0 
  }
  Vue.set(state.affiliateForm, field, value)
}

function updateManagerForm (state, { field, value }) {
  Object.assign(state.managerForm, {
    [field]: value
  })
}

function updateAdministratorForm (state, { field, value }) {
  Object.assign(state.administratorForm, {
    [field]: value
  })
}

function updateSelectedTab (state, payload) {
  state.userModal.selectedTab = payload
}

function setUserForm (state, { user }) {
  _.each(user, (value, key) => {
    state.userForm[key] = value
  })
}

function setBillingAddressForm (state, { billingAddress }) {
  _.each(billingAddress, (value, key) => {
    state.billingAddressForm[key] = value
  })
}

function setShippingAddressForm (state, { shippingAddress }) {
  _.each(shippingAddress, (value, key) => {
    state.shippingAddressForm[key] = value
  })
}

function setInstructorForm (state, INSTRUCTOR) {
  if(!INSTRUCTOR) return state.instructorForm = _.cloneDeep(initialState.instructorForm)

  INSTRUCTOR.ACTIVE_IND = checkboxValue(INSTRUCTOR.ACTIVE_IND)
  state.instructorForm = { ...INSTRUCTOR }
}

function setAffiliateForm (state, AFFILIATE) {
  if(!AFFILIATE) return state.affiliateForm = _.cloneDeep(initialState.affiliateForm)

  AFFILIATE.ACTIVE_IND = checkboxValue(AFFILIATE.ACTIVE_IND)
  state.affiliateForm = { ...AFFILIATE }
}

function setRecruiterForm (state, RECRUITER) {
  if(!RECRUITER) return state.recruiterForm = _.cloneDeep(initialState.recruiterForm)

  RECRUITER.ACTIVE_IND = checkboxValue(RECRUITER.ACTIVE_IND)
  state.recruiterForm = { ...state.recruiterForm, ...RECRUITER }
}

function setManagerForm (state, MANAGER) {
  if(!MANAGER) return state.managerForm = _.cloneDeep(initialState.managerForm)

  MANAGER.ACTIVE_IND = checkboxValue(MANAGER.ACTIVE_IND)
  state.managerForm = { ...MANAGER }
}

function setAdministratorForm (state, ADMINISTRATOR) {
  if(!ADMINISTRATOR) return state.administratorForm = _.cloneDeep(initialState.administratorForm)

  ADMINISTRATOR.ACTIVE_IND = checkboxValue(ADMINISTRATOR.ACTIVE_IND)
  state.administratorForm = { ...ADMINISTRATOR }
}

function setNotificationSettings (state, NOTIFICATION_SETTINGS) {
  if (NOTIFICATION_SETTINGS) {
    let settings = JSON.parse(NOTIFICATION_SETTINGS.USER_NOTIFICATION_SETTINGS)
    
    settings.forEach(ns => {
      let existingKey = initialState.notificationSettings.items.find(x => x.key == ns.key)
      if(existingKey){
        ns.description = existingKey.description
        ns.permissions = existingKey.permissions
      }
    })
    
    state.notificationSettings = {
      USER_NOTIFICATION_SETTINGS_ID: NOTIFICATION_SETTINGS.USER_NOTIFICATION_SETTINGS_ID,
      items: settings
    }
  }
  else {
    state.notificationSettings = _.cloneDeep(initialState.notificationSettings)
  }
}

function clearUserForm (state) {
  _.each(state.userForm, (value, key) => {
    state.userForm[key] = initialState.userForm[key]
  })
}

function clearBillingAddressForm (state) {
  _.each(state.billingAddressForm, (value, key) => {
    state.billingAddressForm[key] = initialState.billingAddressForm[key]
  })
}

function clearShippingAddressForm (state) {
  _.each(state.shippingAddressForm, (value, key) => {
    state.shippingAddressForm[key] = initialState.shippingAddressForm[key]
  })
}

function clearInstructorForm (state) {
  _.each(state.instructorForm, (value, key) => {
    state.instructorForm[key] = initialState.instructorForm[key]
  })
}

function clearRecruiterForm (state) {
  _.each(state.recruiterForm, (value, key) => {
    state.recruiterForm[key] = initialState.recruiterForm[key]
  })
}

function clearAffiliateForm (state) {
  _.each(state.affiliateForm, (value, key) => {
    state.affiliateForm[key] = initialState.affiliateForm[key]
  })
}

function clearManagerForm (state) {
  _.each(state.managerForm, (value, key) => {
    state.managerForm[key] = initialState.managerForm[key]
  })
  state.managerCourses = _.cloneDeep(initialState.managerCourses)
}

function clearAdministratorForm (state) {
  _.each(state.administratorForm, (value, key) => {
    state.administratorForm[key] = initialState.administratorForm[key]
  })
}

function clearActiveApproval (state) {
  _.each(state.activeApproval, (value, key) => {
    state.activeApproval[key] = ''
  })
}

function changeSearchType (state, type){
  state.searchType = type
}


function resetSearchFields (state){
  state.searchFields = _.cloneDeep(initialState.searchFields)
}


function activeSearchType (state,type){
  state.activeSearchType = type
}

function checkboxValue(value){
  return value ? true : false
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}

function autocompleteAddress(state, {place, type, stateOptions}){
    let a = place.address_components
    state[type].ADDRESS_1 = `${addrPart('street_number',a).long_name || ''} ${addrPart('route',a).long_name || ''}`
    state[type].ADDRESS_2 = ''
    state[type].CITY = `${addrPart('locality',a).long_name || addrPart('sublocality',a).long_name || ''}`
    state[type].COUNTY = `${addrPart('administrative_area_level_2',a).long_name.replace(" County","") || ''}`
    state[type].ZIP_CODE = `${addrPart('postal_code',a).short_name || ''}`
    
    let foundState = _.find(stateOptions,{label: addrPart('administrative_area_level_1',a).short_name.toUpperCase()})
    if(foundState && foundState.value){
      state[type].LK_STATE_ID = foundState.value
    }
}
// Part part of an address based on the type
function addrPart(type,address){
    return _.find(address,{types:[type]}) || {long_name:null,short_name:null}
}